<template>
  <div class="createContent">
    <div class="rowC">
      <div class="colC">
       <div class="row2C">
          <div class="TypeContent">
            <Select
              v-model="Client.iteamSelected"
              description="Nom*"
              :options="iteamSelect"
              label="nom"
            />
          </div>
          <div class="Nomcontent">
            <Input
              v-model="Client.first_name"
              datatype="text"
              placeholder="Nom"
              description=""
            />
          </div>
        </div>
      </div>
      <div class="colC">
        <Input
          v-model="Client.last_name"
          datatype="text"
          placeholder="Prénom"
          description="Prénom*"
        />
      </div>
    </div>
    <div class="rowC">
      <div class="colC">
      <Input
          v-model="Client.email"
          datatype="email"
          placeholder="Mail"
          description="Mail*"
        />
        </div>
        <div class="colC">
        <Input
          v-model="Client.tel"
          datatype="tel"
          placeholder="Téléphone"
          description="Téléphone"
        /></div>

    </div>
    <div class="rowC">
      <div class="colC">
      <div class="Inline">
          <span>Adresse</span>
          <textarea
            v-model="Client.adresse"
            name="w3review"
            rows="4"
            cols="45"
            placeholder="Adresse"
          />
        </div>
      </div>
      <div class="colC">
        <Input
          v-model="Client.mobile"
          datatype="tel"
          placeholder="Mobile"
          description="Mobile"
        />
      </div>
    </div>
    <div class="rowC">
      <div class="colC">
        <Input
          v-model="Client.zipCode"
          datatype="number"
          placeholder="Code Postal"
          description="Code Postal"
        />
      </div>
      <div class="colC">
        <Input
          v-model="Client.ville"
          datatype="text"
          placeholder="Ville"
          description="Ville"
        />
      </div>
    </div>
    <div class="rowC">
        <button class="btn" @click="AddClient">Créer</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Input from "./Input";
import Select from "./Select";
export default {
  data() {
    return {
      iteamSelect: [
        { nom: "Mr.", value: "monsieur" },
        { nom: "M.", value: "madame" },
      ],
      Client: {
        iteamSelected: "madame",
        first_name: null,
        email: null,
        adresse: null,
        zipCode: null,
        last_name: null,
        tel: null,
        mobile: null,
        ville: null,
      },
    };
  },
  components: {
    Input,
    Select,
  },
  methods:{
    ...mapActions(['addClient']),
   async AddClient(){
      console.log('new client',this.Client)
      this.Client.ref=this.Client.first_name + " " +this.Client.last_name     
      if(await this.addClient({ ...this.Client })){
         this.$router.replace("/client");
      }

    }
  }
};
</script>

<style scoped lang="scss">
.createContent {
  width: 100%;
  display: inline;
  .rowC {
    width: 100%;
    display: flex;
    .colC {
      width: 50%;
      display: inline;
      .row2C {
        display: flex;
        margin: 9px;
        margin-top: 0px;
        .Nomcontent {
          width: 71%;
          margin-top: 20px;
        }
        .TypeContent {
          width: 28%;
        }
      }
      .Inline {
        width: 100%;
        display: block;
        margin: 8px;
        span {
          margin: 8px;
          color:#a6aeaf;
        }
        textarea {
          margin-left: 8px;
          margin-top:5px;
          width: 89%;
          border: 1px solid #a6aeaf;
          outline: 0;
        }
      }
    }
    .btn {
      margin-left:20px;
      margin-top:25px;
      background-color: #068596ba;
      color: white;
      border: 1px solid #22a1b9;
      border-radius: 3px;
      height: 30px;
      width: 100px;
      &:focus {
        outline: 0;
      }
      &:hover {
        border-color: #ff8c00;
        background-color: #ff8c00;
      }
    }
  }
}
@media screen and (max-width: 425px) {
.createContent{
  .rowC{
    display: inline;
  } 
}
}
</style>
